module.exports = __webpack_public_path__ + "img/ico-instagram.9c6e1efc.svg";